import data from "../../utils/constants/data.json";
import CommonComponent from "../common-component/CommonComponent";

const SkillsComponent = () => {
    const { skillsData } = data;

    const skillsLayout = <CommonComponent items={skillsData} />;

    return skillsLayout;
};

export default SkillsComponent;
